module.exports = __webpack_public_path__ + "static/faq-ff9ffc2245cdf7c3409046ff2b3cfcd5.jpg";